"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse = exports.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest = exports.PortalAccountServiceSaveUserMemoResponse = exports.PortalAccountServiceSaveUserMemoRequest = exports.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse = exports.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest = exports.PortalAccountServiceGetDMAccountsResponse = exports.PortalAccountServiceGetDMAccountsRequest = exports.PortalAccountServiceGetTenantByFirestoreIdResponse = exports.PortalAccountServiceGetTenantByFirestoreIdRequest = exports.PortalAccountServiceGetBrandByFirestoreIdResponse = exports.PortalAccountServiceGetBrandByFirestoreIdRequest = exports.PortalAccountServiceGetBrandByIdResponse = exports.PortalAccountServiceGetBrandByIdRequest = exports.PortalAccountServiceGetFanByEmailResponse = exports.PortalAccountServiceGetFanByEmailRequest = exports.PortalAccountServiceGetMeResponse = exports.PortalAccountServiceGetMeRequest = exports.PortalAccountServiceGetFanByFirestoreIdResponse = exports.PortalAccountServiceGetFanByFirestoreIdRequest = exports.PortalAccountServiceUpdateUserResponse = exports.PortalAccountServiceUpdateUserRequest = exports.PortalAccountServiceRegisterUserResponse = exports.PortalAccountServiceRegisterUserRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.account.v1.PortalAccountServiceRegisterUserRequest
 */
class PortalAccountServiceRegisterUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * メールアドレス
         *
         * @generated from field: string email = 3;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceRegisterUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceRegisterUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceRegisterUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceRegisterUserRequest, a, b);
    }
}
exports.PortalAccountServiceRegisterUserRequest = PortalAccountServiceRegisterUserRequest;
PortalAccountServiceRegisterUserRequest.runtime = protobuf_1.proto3;
PortalAccountServiceRegisterUserRequest.typeName = "spwn.account.v1.PortalAccountServiceRegisterUserRequest";
PortalAccountServiceRegisterUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceRegisterUserResponse
 */
class PortalAccountServiceRegisterUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceRegisterUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceRegisterUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceRegisterUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceRegisterUserResponse, a, b);
    }
}
exports.PortalAccountServiceRegisterUserResponse = PortalAccountServiceRegisterUserResponse;
PortalAccountServiceRegisterUserResponse.runtime = protobuf_1.proto3;
PortalAccountServiceRegisterUserResponse.typeName = "spwn.account.v1.PortalAccountServiceRegisterUserResponse";
PortalAccountServiceRegisterUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: portal_common_pb_1.PortalUser },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceUpdateUserRequest
 */
class PortalAccountServiceUpdateUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * メールアドレス
         *
         * @generated from field: string email = 3;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceUpdateUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceUpdateUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceUpdateUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceUpdateUserRequest, a, b);
    }
}
exports.PortalAccountServiceUpdateUserRequest = PortalAccountServiceUpdateUserRequest;
PortalAccountServiceUpdateUserRequest.runtime = protobuf_1.proto3;
PortalAccountServiceUpdateUserRequest.typeName = "spwn.account.v1.PortalAccountServiceUpdateUserRequest";
PortalAccountServiceUpdateUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceUpdateUserResponse
 */
class PortalAccountServiceUpdateUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceUpdateUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceUpdateUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceUpdateUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceUpdateUserResponse, a, b);
    }
}
exports.PortalAccountServiceUpdateUserResponse = PortalAccountServiceUpdateUserResponse;
PortalAccountServiceUpdateUserResponse.runtime = protobuf_1.proto3;
PortalAccountServiceUpdateUserResponse.typeName = "spwn.account.v1.PortalAccountServiceUpdateUserResponse";
PortalAccountServiceUpdateUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: portal_common_pb_1.PortalUser },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdRequest
 */
class PortalAccountServiceGetFanByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetFanByFirestoreIdRequest, a, b);
    }
}
exports.PortalAccountServiceGetFanByFirestoreIdRequest = PortalAccountServiceGetFanByFirestoreIdRequest;
PortalAccountServiceGetFanByFirestoreIdRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetFanByFirestoreIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdRequest";
PortalAccountServiceGetFanByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdResponse
 */
class PortalAccountServiceGetFanByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetFanByFirestoreIdResponse, a, b);
    }
}
exports.PortalAccountServiceGetFanByFirestoreIdResponse = PortalAccountServiceGetFanByFirestoreIdResponse;
PortalAccountServiceGetFanByFirestoreIdResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetFanByFirestoreIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdResponse";
PortalAccountServiceGetFanByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: portal_common_pb_1.PortalFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetMeRequest
 */
class PortalAccountServiceGetMeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetMeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetMeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetMeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetMeRequest, a, b);
    }
}
exports.PortalAccountServiceGetMeRequest = PortalAccountServiceGetMeRequest;
PortalAccountServiceGetMeRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetMeRequest.typeName = "spwn.account.v1.PortalAccountServiceGetMeRequest";
PortalAccountServiceGetMeRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetMeResponse
 */
class PortalAccountServiceGetMeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetMeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetMeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetMeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetMeResponse, a, b);
    }
}
exports.PortalAccountServiceGetMeResponse = PortalAccountServiceGetMeResponse;
PortalAccountServiceGetMeResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetMeResponse.typeName = "spwn.account.v1.PortalAccountServiceGetMeResponse";
PortalAccountServiceGetMeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: portal_common_pb_1.PortalFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByEmailRequest
 */
class PortalAccountServiceGetFanByEmailRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string email = 1;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByEmailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByEmailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByEmailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetFanByEmailRequest, a, b);
    }
}
exports.PortalAccountServiceGetFanByEmailRequest = PortalAccountServiceGetFanByEmailRequest;
PortalAccountServiceGetFanByEmailRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetFanByEmailRequest.typeName = "spwn.account.v1.PortalAccountServiceGetFanByEmailRequest";
PortalAccountServiceGetFanByEmailRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByEmailResponse
 */
class PortalAccountServiceGetFanByEmailResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByEmailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByEmailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByEmailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetFanByEmailResponse, a, b);
    }
}
exports.PortalAccountServiceGetFanByEmailResponse = PortalAccountServiceGetFanByEmailResponse;
PortalAccountServiceGetFanByEmailResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetFanByEmailResponse.typeName = "spwn.account.v1.PortalAccountServiceGetFanByEmailResponse";
PortalAccountServiceGetFanByEmailResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: portal_common_pb_1.PortalFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByIdRequest
 */
class PortalAccountServiceGetBrandByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetBrandByIdRequest, a, b);
    }
}
exports.PortalAccountServiceGetBrandByIdRequest = PortalAccountServiceGetBrandByIdRequest;
PortalAccountServiceGetBrandByIdRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetBrandByIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByIdRequest";
PortalAccountServiceGetBrandByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByIdResponse
 */
class PortalAccountServiceGetBrandByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetBrandByIdResponse, a, b);
    }
}
exports.PortalAccountServiceGetBrandByIdResponse = PortalAccountServiceGetBrandByIdResponse;
PortalAccountServiceGetBrandByIdResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetBrandByIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByIdResponse";
PortalAccountServiceGetBrandByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: portal_common_pb_1.PortalBrand },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdRequest
 */
class PortalAccountServiceGetBrandByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetBrandByFirestoreIdRequest, a, b);
    }
}
exports.PortalAccountServiceGetBrandByFirestoreIdRequest = PortalAccountServiceGetBrandByFirestoreIdRequest;
PortalAccountServiceGetBrandByFirestoreIdRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetBrandByFirestoreIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdRequest";
PortalAccountServiceGetBrandByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdResponse
 */
class PortalAccountServiceGetBrandByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetBrandByFirestoreIdResponse, a, b);
    }
}
exports.PortalAccountServiceGetBrandByFirestoreIdResponse = PortalAccountServiceGetBrandByFirestoreIdResponse;
PortalAccountServiceGetBrandByFirestoreIdResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetBrandByFirestoreIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdResponse";
PortalAccountServiceGetBrandByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: portal_common_pb_1.PortalBrandCore },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdRequest
 */
class PortalAccountServiceGetTenantByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_firestore_id = 1;
         */
        this.tenantFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetTenantByFirestoreIdRequest, a, b);
    }
}
exports.PortalAccountServiceGetTenantByFirestoreIdRequest = PortalAccountServiceGetTenantByFirestoreIdRequest;
PortalAccountServiceGetTenantByFirestoreIdRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetTenantByFirestoreIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdRequest";
PortalAccountServiceGetTenantByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdResponse
 */
class PortalAccountServiceGetTenantByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetTenantByFirestoreIdResponse, a, b);
    }
}
exports.PortalAccountServiceGetTenantByFirestoreIdResponse = PortalAccountServiceGetTenantByFirestoreIdResponse;
PortalAccountServiceGetTenantByFirestoreIdResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetTenantByFirestoreIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdResponse";
PortalAccountServiceGetTenantByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant", kind: "message", T: portal_common_pb_1.PortalTenant },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetDMAccountsRequest
 */
class PortalAccountServiceGetDMAccountsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetDMAccountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetDMAccountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetDMAccountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetDMAccountsRequest, a, b);
    }
}
exports.PortalAccountServiceGetDMAccountsRequest = PortalAccountServiceGetDMAccountsRequest;
PortalAccountServiceGetDMAccountsRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetDMAccountsRequest.typeName = "spwn.account.v1.PortalAccountServiceGetDMAccountsRequest";
PortalAccountServiceGetDMAccountsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetDMAccountsResponse
 */
class PortalAccountServiceGetDMAccountsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.PortalDMBrand brands = 2;
         */
        this.brands = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetDMAccountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetDMAccountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetDMAccountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetDMAccountsResponse, a, b);
    }
}
exports.PortalAccountServiceGetDMAccountsResponse = PortalAccountServiceGetDMAccountsResponse;
PortalAccountServiceGetDMAccountsResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetDMAccountsResponse.typeName = "spwn.account.v1.PortalAccountServiceGetDMAccountsResponse";
PortalAccountServiceGetDMAccountsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: portal_common_pb_1.PortalDMUser },
    { no: 2, name: "brands", kind: "message", T: portal_common_pb_1.PortalDMBrand, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest
 */
class PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest, a, b);
    }
}
exports.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest = PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest;
PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest";
PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse
 */
class PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse, a, b);
    }
}
exports.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse = PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse;
PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse";
PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "core_fan", kind: "message", T: portal_common_pb_1.PortalAccountCoreFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceSaveUserMemoRequest
 */
class PortalAccountServiceSaveUserMemoRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = "";
        /**
         * @generated from field: string memo = 3;
         */
        this.memo = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceSaveUserMemoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceSaveUserMemoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceSaveUserMemoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceSaveUserMemoRequest, a, b);
    }
}
exports.PortalAccountServiceSaveUserMemoRequest = PortalAccountServiceSaveUserMemoRequest;
PortalAccountServiceSaveUserMemoRequest.runtime = protobuf_1.proto3;
PortalAccountServiceSaveUserMemoRequest.typeName = "spwn.account.v1.PortalAccountServiceSaveUserMemoRequest";
PortalAccountServiceSaveUserMemoRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceSaveUserMemoResponse
 */
class PortalAccountServiceSaveUserMemoResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceSaveUserMemoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceSaveUserMemoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceSaveUserMemoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceSaveUserMemoResponse, a, b);
    }
}
exports.PortalAccountServiceSaveUserMemoResponse = PortalAccountServiceSaveUserMemoResponse;
PortalAccountServiceSaveUserMemoResponse.runtime = protobuf_1.proto3;
PortalAccountServiceSaveUserMemoResponse.typeName = "spwn.account.v1.PortalAccountServiceSaveUserMemoResponse";
PortalAccountServiceSaveUserMemoResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest
 */
class PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest, a, b);
    }
}
exports.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest = PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest;
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest.runtime = protobuf_1.proto3;
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest";
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse
 */
class PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string brand_firestore_ids = 1;
         */
        this.brandFirestoreIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse, a, b);
    }
}
exports.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse = PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse;
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse.runtime = protobuf_1.proto3;
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse";
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
//# sourceMappingURL=portal_service_pb.js.map